import React, { Component } from 'react';
import styled from 'styled-components';

class SelectBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      disabled : props.disabled || false,
      selectedValue: props.defaultValue || '',
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
  }

  componentDidUpdate() {
    if (this.state.isOpen) {
      document.addEventListener('click', this.closeDropdown)
    }
    if (!this.state.isOpen) {
      document.removeEventListener('click', this.closeDropdown)
    }
  }

  closeDropdown = () => {
    this.setState({ isOpen: false });
  }

  handleToggle = () => {
     if (this.state.disabled) return;
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };


  render() {
    const {
      options = [],
      selectedValue,
      onChange
    } = this.props;

    var classNames = 'select' ;
    if (this.state.disabled) {
      classNames += ' disabled';
    }

    const {
      isOpen,
    } = this.state;
    return (
      <SelectContainer>
        <div
          className={classNames}
          onClick={this.handleToggle}
        >
          <p>
            {selectedValue || '선택하세요.'}
          </p>
          {
            isOpen && (
              <div className='option-container'>
                {
                  options.map((option, index) => (
                    <div
                      key={`option-${index}-${option?.id}`}
                      className='option'
                      onClick={() => {
                        onChange(option?.id)
                        this.setState({ isOpen: false })
                      }}
                    >
                      <label htmlFor={option?.type}>
                        {option?.type}
                      </label>
                    </div>
                  ))
                }
              </div>
            )
          }
        </div>
      </SelectContainer>
    )
  }
}

const SelectContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 436px;
  border: 1px solid #d5d8de;
  border-radius: 4px;
  .select {
    position: relative;
    width: 100%;
    cursor: pointer;
    p {
      width: 100%;
      padding: 10px 12px;
      background-color: transparent;
      border: 1px solid #fff;
      border-width: 0 0 1px 0;
      text-align: left;
      font-size: 15px;
      font-weight: 500;
      color: #262626;
    }
  }
  .select::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 10px solid #333;
  }
  .select.disabled {
    background-color: #f8f8f8;
    border-radius: 4px;
    p {
      color: #848484;
    }
  }
  .select.disabled::after {
    border-top: 10px solid #969696;
  }
  .option-container {
    position: absolute;
    top: 50px;
    width: 100%;
    background-color: #fff;
    border: 1px solid #d5d8de;
    border-radius: 5px;
    box-shadow: 0 3px 10px 0 rgba(68, 69, 71, 0.15);
    padding: 8px;
    z-index: 10;

    .option {
      display: block;
      padding: 0;

      &.disabled {
        color: #aaa;
        cursor: not-allowed;
      }

      &.disabled label {
        color: #aaa;
      }

      &:not(.disabled):hover label {
        background-color: #f8f9fe;
      }

      label {
        font-weight: 500;
        text-align: center;
        display: block;
        font-size: 16px;
        color: #191919;
        padding: 10px 12px;
        cursor: pointer;
        text-align: left;
      }

      &:first-child:hover label,
      &:first-child label.selected {
        border-radius: 5px 5px 0 0;
      }

      &:last-child:hover label,
      &:last-child label.selected {
        border-radius: 0 0 5px 5px;
      }
    }
  }
`;

export default SelectBox;